import { AppNames, SingleSpaEventDetail } from "../types/singleSpa.types";
import { getMountedApps } from "single-spa";
import { SELF_HANDLED_SCROLLING_APPS } from "../constants/index";

export const isScrollingHandledByMf = (): boolean =>
	getMountedApps().some((mountedApp) => SELF_HANDLED_SCROLLING_APPS.includes(mountedApp));
export const isValidRouterNavigation = ({ oldUrl, newUrl }: SingleSpaEventDetail): boolean => oldUrl !== newUrl;
export const isSingleSpaPushState = ({ originalEvent }: SingleSpaEventDetail): boolean =>
	originalEvent?.singleSpaTrigger === "pushState";
export const isScrollTop = (detail: SingleSpaEventDetail): boolean =>
	!isScrollingHandledByMf() && isSingleSpaPushState(detail);

export const isAppMounted = (appName: AppNames): boolean => getMountedApps().includes(appName);

export const getUrlFromPath = (path: string): URL => {
	if (path.startsWith("https://") || path.startsWith("http://")) {
		return new URL(path);
	}
	return new URL(path, window.location.origin);
};

export const shouldFocusFirstElement = (detail: SingleSpaEventDetail): boolean => {
	if (!isAppMounted("mf-productlist")) return true;

	const newUrl = new URL(detail.newUrl);
	const oldUrl = new URL(detail.oldUrl);
	// navigation to search result page
	if (newUrl.pathname.endsWith("/suche/") && !oldUrl.pathname.endsWith("/suche/")) return false;

	// filter or sorting changed on search result page
	if (newUrl.pathname.endsWith("/suche/") && oldUrl.pathname.endsWith("/suche/")) {
		const newHash = newUrl.hash.replace("#/Kategorie/", "");
		const oldHash = oldUrl.hash.replace("#/Kategorie/", "");
		const newCategory = newHash.slice(0, newHash.includes("/") ? newHash.indexOf("/") : undefined);
		const oldCategory = oldHash.slice(0, oldHash.includes("/") ? oldHash.indexOf("/") : undefined);
		return newCategory !== oldCategory;
	}

	// filter or sorting changed on product list page
	return newUrl.pathname !== oldUrl.pathname;
};
